import { __assign, __awaiter, __generator } from "tslib";
import { request } from '../lib/request';
export var loadBoundCardsApi = function (apiHost, serviceToken, loadSbpTokens) { return __awaiter(void 0, void 0, void 0, function () {
    var params, data, methods;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (loadSbpTokens) {
                    params = {
                        'show_sbp_tokens': 'true'
                    };
                }
                return [4, request({
                        method: 'GET',
                        url: "".concat(apiHost, "/web/payment_methods"),
                        headers: serviceToken ? { 'X-Service-Token': serviceToken } : undefined,
                        params: params
                    })];
            case 1:
                data = _a.sent();
                methods = data.payment_methods;
                return [2, Object.keys(methods)
                        .filter(function (id) { return id.startsWith('card') || id.startsWith('sbp'); })
                        .map(function (id) { return (__assign(__assign({}, methods[id]), { 'method_id': methods[id].id, id: id })); })];
        }
    });
}); };
